module.exports = __webpack_public_path__ + "static/img/product.133ca5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/product/product.jpg
// module id = XqvY
// module chunks = 0